import { defineStore } from 'pinia';
import { actions, getters, state } from '@/stores/methods';

export const useAgentIsTypingStore = defineStore('agentIsTyping', {
  state: state,
  getters: {
    findByConversation: (state) => {
      return (conversationId, currentAgentId) => state.collection.filter(a => a.conversationId === conversationId && a.agentId !== currentAgentId);
    },
    ...getters,
  },
  actions: actions,
});
